module.exports = __webpack_public_path__ + "img/container1Model.8c93e9b2.png";